import React, { useEffect, useState } from "react";
import { Editor } from "@monaco-editor/react";

export default function CodeEditor(props) {

    const { code, defaultLanguage='python', handleChange } = props;

    return (
        <Editor
            height='100%'
            defaultLanguage={defaultLanguage}
            value={code}
            theme='vs-dark'
            onChange={handleChange}
            options={{
                automaticLayout: true,
                fontSize: 12,
                formatOnPaste: true,
                formatOnType: true,
                minimap: { enabled: false },
                quickSuggestions: true,
                scrollBeyondLastLine: false,
                suggestOnTriggerCharacters: true,
                wordWrap: "on",
            }}
        />
    )
}